module.exports = require("./gsw-CH.js");